<template>
    <b-modal
        v-model="modalVisible"
        size="lg"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        <template v-slot:modal-title>
            <div class="pb-2">Enviar pedido a Odoo - ORDEN #{{ orderId }}</div>
        </template>
        
        <!-- Información de la orden -->
        <b-row class="mb-3" v-if="orderData">
            <b-col cols="12">
                <div class="p-2 bg-light rounded">
                    <p class="mb-0"><strong>Orden:</strong> #{{ orderId }}</p>
                    <p class="mb-0" v-if="orderData.customer"><strong>Cliente:</strong> {{ orderData.customer }}</p>
                    <p class="mb-0" v-if="orderData.date"><strong>Fecha:</strong> {{ orderData.date }}</p>
                </div>
            </b-col>
        </b-row>
        
        <b-row>
            <b-col cols="12">
                <p class="font-weight-medium">Seleccione a que instancia quiere enviar:</p>
            </b-col>
            <b-col cols="12">
                <b-form-select
                    v-model="selectedOdooInstanceId"
                     :options="[
                        { value: null, label: 'Seleccione una instancia', disabled: true },
                        ...activeOdooInstancesOptions
                    ]"
                    value-field="id"
                    text-field="label"
                    class="mb-3"
                ></b-form-select>
            </b-col>
        </b-row>

        
        <template v-slot:modal-footer>
            <b-button variant="secondary" @click.prevent="closeModal">
                Cancelar
            </b-button>
            <b-button 
                variant="primary" 
                @click.prevent="sendToOdoo"
                :disabled="!isValidChoice"
            >
                Enviar a Odoo
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "sendOrderToOdooModal",
    props: {
        modalVisible: {
            type: Boolean,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        orderId: {
            type: [String, Number],
            required: true
        },
        orderData: {
            type: Object,
            default: () => ({})
        },
        odooInstances: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectedOdooInstanceId: null
        }
    },
    computed: {
        activeOdooInstancesOptions() {
            return this.odooInstances
                .filter(instance => instance.status === true)
                .map(instance => ({
                    id: instance.id,
                    label: `${instance.name} - ${instance.mode === 'production' ? 'Producción' : 'Pruebas'}`
                }));
        },
        isValidChoice() {
            return this.selectedOdooInstanceId !== null;
        }
    },
    methods: {
        sendToOdoo() {
            this.$emit('send-to-odoo', this.selectedOdooInstanceId);
        },
        closeModal() {
            // Reiniciar el estado al cerrar
            this.selectedOdooInstanceId = null;
            this.$emit('close-modal');
        }
    },
    watch: {
        // Reiniciar cuando se abre el modal
        modalVisible(newVal) {
            if (newVal) {
                this.selectedOdooInstanceId = null;
            }
        }
    }
};
</script>